import {Overlay} from '../shared/overlay'
import {DeleteCallHomeRequests} from './components/delete-chr-form'

export function DeleteCallHomeRequestsModal(): JSX.Element {
    return (
        <Overlay
            onClickFn={(e) => {
                e && e.preventDefault()
            }}
            z={900}>
            <DeleteCallHomeRequests />
        </Overlay>
    )
}
